import { render, staticRenderFns } from "./ChallengeModal.vue?vue&type=template&id=0ec6dff3&scoped=true&"
import script from "./ChallengeModal.vue?vue&type=script&lang=js&"
export * from "./ChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeModal.vue?vue&type=style&index=0&id=0ec6dff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec6dff3",
  null
  
)

export default component.exports